<template>
  <div v-loading="loading" class="AProductionBomTree">
    <ATree
      value-field-name="id"
      text-field-name="name"
      :data="nodes"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ATree from "./ATree";

export default {
  name: "AProductionBomTree",
  components: { ATree },
  data() {
    return {
      nodes: [], // BOM을 트리구조로 변환한 배열
      loading: false,
    };
  },
  props: {
    data: Object,
  },
  mounted() {
    this.loadData();
  },
  computed: {
    ...mapGetters(["table_product", "table_unit"])
  },
  methods: {
    loadData() {      
      this.loading = true;
      this.data.bom.forEach(bom => {
        this.makeNode(bom);
      });
      this.loading = false;
    },
    /**
     * BOM 정보는 tree 구조 상위부터 순차적으로 저장이 되어 있다.
     * 따라서 특정 노드의 parent는 반드시 그 전에 node에 등록이 되어 있다.
     */
    makeNode(bom) {
      let product = this.getProduct(bom.product_id);
      let icon = "fas fa-cog";
      if (bom.bom_id) {
        icon = this.hasChildren(bom.bom_id) ? "fas fa-box" : "fas fa-cog"
      }
      if (!bom.unit_id) {
        bom.unit_id = 1;
      }
      let unit = this.table_unit.find(u => u.id === bom.unit_id);
      let node = {
        id: bom.bom_id,
        name: product.name,
        children: [],
        icon: icon,
      }
      if (bom.size) {
        node.name += " [" + bom.size + "]"
      }
      node.name += " " + bom.amount + unit.name;
      if (bom.modified) {
        node.icon += " modified";
      }
      if (bom.parent_id) {
        let parent = this.searchParentNode(this.nodes, bom.parent_id);        
        parent.children.push(node);
      } else {
        this.nodes.push(node);
      }
    },
    searchParentNode(nodes, id) {
      let node = nodes.find(node => node.id === id)
      if (node) { return node; }
      nodes.forEach(n => {
        if (n.children.length > 0) {
          node = this.searchParentNode(n.children, id);  
        }
        if (node) { return true; }
      })
      return node;
    },
    /**
     * material과 production에 제품 정보가 저장되어 있기 때문에
     * 해당 배열에서 제품 정보를 찾는다.
     */
    getProduct(id) {
      let item = this.data.material.find(d => d.id === id);
      if (!item) {
        item = this.data.production.find(d => d.id === id);
      }
      return item;
    },
    hasChildren(id) {
      return this.data.bom.find(b => b.parent_id === id);
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/css/_variables.scss";

.AProductionBomTree {
  .modified { color: $color-danger; }
}
</style>